import { render, staticRenderFns } from "./addPhone.vue?vue&type=template&id=06a1e7f4&scoped=true&"
import script from "./addPhone.vue?vue&type=script&lang=js&"
export * from "./addPhone.vue?vue&type=script&lang=js&"
import style0 from "./addPhone.vue?vue&type=style&index=0&id=06a1e7f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1e7f4",
  null
  
)

export default component.exports